import { el } from '../dom.js';
import type { I18n } from '../i18n.js';

/**
 * §8 replay-защита / GDPR. Явный экран между debrief и созданием replay-сессии.
 *
 * Две независимые оси решения:
 *   1. Связать сессии? (opt-in по §8 — без галочки priorSessionId не сохраняется)
 *   2. Всё равно играть сейчас, несмотря на предупреждение §9 G1 / §21.1?
 *
 * Decline → возврат на landing, cookie остаётся — при следующем POST /api/session
 * новая сессия всё равно будет помечена isReplay=true по cookie (R3), но без
 * priorSessionId.
 *
 * Link → POST /api/session с replayConsent=true: priorSessionId сохраняется,
 * роль выбирается как контраст к предыдущей.
 *
 * Continue (без связки) → POST /api/session с replayConsent=false.
 */
export interface ReplayConsentProps {
  i18n: I18n;
  onContinue: (linkPriorSession: boolean) => void;
  onDecline: () => void;
}

export function ReplayConsentView({ i18n, onContinue, onDecline }: ReplayConsentProps): HTMLElement {
  let linkChecked = false;
  const checkbox = el('input', {
    type: 'checkbox',
    id: 'replay-link-consent',
    onChange: (ev: Event) => {
      linkChecked = (ev.target as HTMLInputElement).checked;
    },
  }) as HTMLInputElement;

  return el('section', { class: 'stack-lg', 'aria-label': i18n.t('replay.consent_heading') }, [
    el('header', {}, [
      el('h1', {}, i18n.t('replay.consent_heading')),
      el('p', { class: 'hero-lede' }, i18n.t('replay.consent_body')),
    ]),
    el('section', { class: 'debrief-section' }, [
      el('h2', {}, i18n.t('replay.consent_warning_heading')),
      el('p', {}, i18n.t('replay.consent_warning_body')),
    ]),
    el('section', { class: 'debrief-section' }, [
      el('label', { for: 'replay-link-consent', class: 'consent-row' }, [
        checkbox,
        el('span', {}, i18n.t('replay.consent_link_label')),
      ]),
      el('p', { class: 'hero-lede' }, i18n.t('replay.consent_link_note')),
    ]),
    el('div', { class: 'actions' }, [
      el('div', { class: 'actions-secondary' }, [
        el('button', { class: 'secondary', onClick: () => onDecline() }, i18n.t('replay.consent_decline')),
        el('button', { onClick: () => onContinue(linkChecked) }, i18n.t('replay.consent_continue')),
      ]),
    ]),
  ]);
}
